export enum StorageKeysEnum {
  jwt = 'jwt',
  i18nextLng = 'i18nextLng',
  clickedURL = 'clickedURL',
  onboarding = 'onboarding',
}
